import { LanguageCode } from '../types';

export const DEFAULT_LANGUAGE = LanguageCode.EN;

export const SUPPORTED_LANGUAGES = Object.values(LanguageCode);

export const REAL_LANGUAGES = Object.values(LanguageCode).filter(
	(code) => code !== LanguageCode.AUTO,
);
